module.exports = __webpack_public_path__ + "img/icon_solucoesTecnologia4.a3c957ff.jpg";